/* eslint-disable */
import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const { token } = useParams();
  const history = useHistory();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (password !== confirmPassword) {
      return setMessage("Passwords do not match");
    }

    try {
      setLoading(true);

      const res = await axios.post(
        "http://localhost:5000/api/auth/reset-password",
        { token, password }
      );

      setMessage(res.data.message || "Password updated");

      setTimeout(() => {
        history.push("/login");
      }, 2000);

    } catch (err) {
      setMessage(err.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="container">
        <div className="loginbox">
          <div className="login-right">
            <div className="login-right-wrap">

              <h1>Reset Password</h1>

              <form onSubmit={handleSubmit}>
                <input
                  className="form-control mb-3"
                  type="password"
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <input
                  className="form-control mb-3"
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />

                <button className="btn btn-primary w-100">
                  {loading ? "Updating..." : "Reset Password"}
                </button>
              </form>

              {message && (
                <p className="text-center mt-3 text-danger">
                  {message}
                </p>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;